import { FormControl, MenuItem, OutlinedInput, Select } from '@mui/material'
import React, { useState } from 'react'

const languageOptions = [
  { flag: 'british_flag.png', lang: 'British English', alt: 'British Flag' },
  { flag: 'America_Flag.svg', lang: 'American English', alt: 'American Flag' },
  { flag: 'france.svg', lang: 'French', alt: 'French Flag' },
  { flag: 'spain.svg', lang: 'Spanish', alt: 'Spanish Flag' },
  // Add more languages as needed
]

const LanguageSelect = () => {
  const [language, setLanguage] = useState({
    flag: 'british_flag.png',
    lang: 'English',
    alt: 'British Flag',
  })

  return (
    <FormControl className="language-select language-select--sm !border rounded-lg">
      <Select
        id="simple-select"
        value={language}
        displayEmpty
        onChange={(e) => setLanguage(e.target.value)}
        style={{
          height: '40px',
          maxHeight: '40px',
          borderRadius: '8px',
        }}
        input={
          <OutlinedInput
            sx={{
              borderWidth: '1px',
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: '#F67443',
              },
              '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: '#F67443',
              },
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: '#F67443',
                borderWidth: '1px',
              },
            }}
          />
        }
        renderValue={(selected) => {
          return (
            <div className="flex gap-1.5">
              <img src={`/assets/image/${language.flag}`} className="me-2" alt={language.lang} />
              {/* <span className="text-[#F67443]">{language.lang}</span> */}
            </div>
          )
        }}
        inputProps={{ 'aria-label': 'Without label' }}
      >
        {/* <MenuItem
          className="!text-[#F67443]"
          value={{ flag: 'America_Flag.svg', lang: 'A-Englsih' }}
        >
          <div className="flex gap-1.5">
            <img src={`/assets/image/America_Flag.svg`} className="me-2" alt={'america'} />
            <span className="text-[#F67443]">A-English</span>
          </div>
        </MenuItem> */}
        <MenuItem className="!text-green-500" value={{ flag: 'Canada_Flag.svg', lang: 'Englsih' }}>
          <div className="flex gap-1.5">
            <img src={`/assets/image/Canada_Flag.svg`} className="me-2" alt={'canada'} />
            <span className="text-[#F67443]">English</span>
          </div>
        </MenuItem>
      </Select>
    </FormControl>
  )
}

export default LanguageSelect
